__turbopack_context__.v({
  "appsColumn": "AssetTable-module__jmhx_W__appsColumn",
  "assetTable": "AssetTable-module__jmhx_W__assetTable",
  "lastModifiedColumn": "AssetTable-module__jmhx_W__lastModifiedColumn",
  "lastRunColumn": "AssetTable-module__jmhx_W__lastRunColumn",
  "locationColumn": "AssetTable-module__jmhx_W__locationColumn",
  "readOnlyFolderAlert": "AssetTable-module__jmhx_W__readOnlyFolderAlert",
  "searchClearButton": "AssetTable-module__jmhx_W__searchClearButton",
  "searchLabel": "AssetTable-module__jmhx_W__searchLabel",
  "searchNoResults": "AssetTable-module__jmhx_W__searchNoResults",
  "searchWrapper": "AssetTable-module__jmhx_W__searchWrapper",
  "statusColumn": "AssetTable-module__jmhx_W__statusColumn",
  "tabLabel": "AssetTable-module__jmhx_W__tabLabel",
  "tabsWrapper": "AssetTable-module__jmhx_W__tabsWrapper",
  "trashEmptyState": "AssetTable-module__jmhx_W__trashEmptyState",
  "trashRetentionAlert": "AssetTable-module__jmhx_W__trashRetentionAlert",
});
